module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "owl-carousel"
  }, [_vm._l((_vm.items), function(item) {
    return [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "cols s_24 m___16 l___24"
    }, [_c('div', {
      staticClass: "header"
    }, [_vm._v(_vm._s(item.header))]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), (item.link) ? _c('a', {
      staticClass: "button1",
      attrs: {
        "href": item.link.href
      }
    }, [_vm._v(_vm._s(item.link.textButton))]) : _vm._e(), _vm._v(" "), (item.button) ? _c('a', {
      staticClass: "button1",
      attrs: {
        "data-fancybox": "",
        "data-src": ("#" + (item.button.popupFormID)),
        "href": ("#" + (item.button.popupFormID)),
        "data-key": item.button.key
      },
      on: {
        "click": function($event) {
          return _vm.eventPopup(item.button.key)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.button.textButton) + "\n\t\t\t\t\t\t")]) : _vm._e()])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cols s_24",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('ul', {
    staticClass: "grid s_5 m_3 m___5",
    attrs: {
      "count": _vm.items ? _vm.items.length : 0
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": item.button2.href,
        "data-id": item.id
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('span', {
      staticClass: "one",
      style: (("background-image: url(\"" + (item.button2.icon) + "\")"))
    }), _vm._v(" "), _c('span', {
      staticClass: "two",
      style: (("background-image: url(\"" + (item.button2["icon-hover"]) + "\")"))
    })]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.button2.text))])])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ab8baaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/index-video.vue
// module id = 399
// module chunks = 14